<template>
    <v-container fluid fill-height="fill-height">
        <v-overlay :value="loading">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
        <v-app-bar
        app
        clipped-right
        color="white"
        dark
        >
        <v-app-bar-title>
            <v-img
            src="../assets/Logo-NameBlack-1024x337.png"
            :width="isMobile ? 130 : 150"
            contain
            position="center center"
            style="text-align: center"
            ></v-img>
        </v-app-bar-title>
        <!--
        <v-btn icon x-small>
            <v-icon>fa fa-user</v-icon>
        </v-btn>
        -->
        <v-spacer></v-spacer>
            <v-btn x-small color="black" text @click="logout">
                <v-icon small class="pr-1">fa fa-sign-out-alt</v-icon> Log out
            </v-btn>
        </v-app-bar>
        <v-card width="100%" flat style="background: transparent; position: absolute; top: 0; bottom: 0; left: 0; right: 0">
            <v-card-text>
                <v-row class="justify-center flex-column align-center">
                    <v-col md="12" class="text-center">
                        <h1 class="black--text text-h5 font-weight-bold">Welcome to Snatch Console</h1>
                    </v-col>
                    <v-col cols="12" md="6" style="display: flex;" class="justify-center"><h2 class="text-body-2" style="color: grey">Please select account to proceed</h2></v-col>
                    <v-col md="12">
                        <div v-if="items.length > 0">
                        <v-row>
                            <v-col cold="12" md="2" v-for="(item, index) in items" :key="index" style="display: flex; justify-content: center">
                                <v-row dense>
                                    <v-col cols="12" style="display: flex; justify-content: center">
                                        <v-card
                                        id="no-background-color"
                                        :ripple="false"
                                        @click.prevent="retoken(item, item.islinked)"
                                        class="mb-2 grow2"
                                        :outlined="false" :style="{background: item.color}" style="border-radius: 50%;
                                        width: 140px;
                                        height: 140px;
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;">
                                        <v-row>
                                            <v-col cols="12" md="12" style="display: flex; justify-content: center; align-items: center;"><div class="text-h4 font-weight-bold blue-grey--text"><v-icon color="white" x-large>{{item.fontclass}}</v-icon></div></v-col>
                                        </v-row>              
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" style="display: flex; justify-content: center">
                                        <span>
                                        <p class="font-weight-bold" style="margin-bottom: unset; text-align: center">{{item.title}}</p>
                                        <p class="black--text" style="margin-bottom: unset; text-align: center">{{item.DisplayName}}</p>
                                        <p class="black--text" style="margin-bottom: unset; text-align: center" v-html="item.ProfileRole_Name === 'Corporate' ? `${item.CorporateName == null ? 'N/A' : item.CorporateName}` : ''"></p>
                                        <p class="black--text" style="margin-bottom: unset; text-align: center" v-html="item.ProfileType_Name === 'Operator' ? `${item.OperatorUserName}` : ''"></p>
                                        <p class="black--text" style="margin-bottom: unset; text-align: center" v-html="item.DisplayMobile === '' ? `<i class='fa fa-star'></i> ${item.ProfileRole_Name}` : item.DisplayMobile"></p>
                                        <p class="black--text" style="margin-bottom: unset; text-align: center" v-html="item.ProfileRole_Name === 'Driver' ? `<i class='fa fa-star'></i> ${item.ProfileRole_Name}` : ''"></p>
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        </div>
                        <div v-else>
                            <h2 class="white--text text-overline">You have no profile therefore unable to proceed further. Please contact support to assist in providing a profile.</h2>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-footer app="app">
      <v-flex class="caption">Copyright By SNATCH PARK BIZSOLUTIONS SDN BHD © 2021</v-flex>
    </v-footer>
        <v-snackbar
            v-model="toaster"
            :color="toasterColor"
            top
            >
            {{ toastertxt }}
        </v-snackbar>
        <linktomobile :dialog="ex.modal" @closed="onClosed" :content="ex.content"></linktomobile>
        <alertbox :dialog="innerModal" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" @confirm="onConfirm" @closed="onClosed"></alertbox>
    </v-container>
</template>

<script>
import linktomobile from '../components/modals/LinkToMobile';
import {ERR} from '../assets/js/errhandle.js';
import {fn} from '../assets/js/themeset.js';
import alertbox from '../components/modals/Alert2';

export default {
    name: 'Select System',

    data(){
        return{
            items: [],
            loading: false,
            isMobile: false,
            toaster: false,
            toastertxt: '',
            toasterColor: 'red',
            bgImages: require("../assets/endless-constellation.svg"),
            ex: {
                modal: false,
                content: ''
            },
            innerModal: false,
            ma: {
                modal_action_type: '',
                modalInfo: [],
                customText: [],
            },
        }
    },

    components: {
        linktomobile,
        alertbox
    },

    created(){
        this.listSystems();
    },

    beforeDestroy () {
      if (typeof window === 'undefined') return

      window.removeEventListener('resize', this.onResize, { passive: true })
    },

    mounted(){
        this.onResize();
        window.addEventListener('resize', this.onResize, { passive: true })
        //this.test1();
    },

    methods: {
        async listSystems(){
            this.loading = true;
            this.items = [];
            let response = await this.$store.dispatch('getSystems', {systemname: ''})
            if (response.data.code == 'AP000'){
                let dt = response.data.record;
                let recordCount = response.data.count;
                let newarr = [];

                let isMobileLinked = dt.some(item => item.Type === 1 && item.Role === 1);
                let isCorporateLinked = dt.some(item => item.Type === 1 && item.Role === 2);

                console.log(isMobileLinked);

                if (!isMobileLinked){
                    newarr.push({
                        Type: 1,
                        Role: 1,
                        fontclass: 'fa fa-user-plus',
                        color: '#FBCE07',
                        DisplayName: "Link to Snatch Mobile App",
                        islinked: false
                    });
                }

                else{
                    let mobileitem = dt.find(item => item.Type === 1 && item.Role === 1);
                    mobileitem.fontclass = 'fa fa-user';
                    mobileitem.color = '#FBCE07';
                    mobileitem.islinked = true;
                    mobileitem.title = "Subscriber Account";
                    mobileitem.displayname = mobileitem.DisplayName;
                    newarr.push(mobileitem);
                }

                if (!isCorporateLinked){
                    newarr.push({
                        Type: 1,
                        Role: 2,
                        fontclass: 'fa fa-user-plus',
                        color: '#ADABB0',
                        DisplayName: "Add Corporate Account",
                        islinked: false
                    });
                }

                else{
                    let corporateitem = dt.find(item => item.Type === 1 && item.Role === 2);
                    corporateitem.fontclass = 'fa fa-user';
                    corporateitem.color = '#ADABB0';
                    corporateitem.islinked = true;
                    corporateitem.title = "Subscriber Account";
                    corporateitem.displayname = corporateitem.CorporateName;
                    newarr.push(corporateitem);
                }

                for(var i=0; i<dt.length; i++){
                    if ( (dt[i].Type !== 1 && dt[i].Role !== 1) || (dt[i].Type !== 1 && dt[i].Role !== 2) )
                    newarr.push({
                        Type: dt[i].Type,
                        Role: dt[i].Role,
                        fontclass: 'fa fa-user',
                        color: '#427AB3',
                        title: 'Operator Account',
                        Operator: dt[i].Operator,
                        Carpark: dt[i].Carpark,
                        ProfileType_Name: dt[i].ProfileType_Name,
                        ProfileRole_Name: dt[i].ProfileRole_Name,
                        OperatorIDCheckList: dt[i].OperatorIDCheckList,
                        OperatorUserName: dt[i].OperatorUserName || 'N/A',
                        ProfileTRSOC: dt[i].ProfileTRSOC,
                        DisplayMobile: dt[i].DisplayMobile,
                        DisplayName: dt[i].DisplayName,
                        displayname: dt[i].OperatorUserName || 'N/A',
                        islinked: true
                    });
                }

                console.log('newarr', newarr);

                this.items = newarr;
                this.pages = Math.ceil(recordCount / 100);
                this.loading = false;
                //this.$vuetify.goTo(0);
            }
        },

        async retoken(item, islink){
            this.loading = true;
            fn.getTheme({type: item.Type, role: item.Role});
            
            try{
                if (islink){
                    let response = await this.$store.dispatch("userRetoken", { profiletrsoc: item.ProfileTRSOC})
                    if (response.data.code == 'AP000'){
                        if ((item.displayname == "N/A" || item.displayname == null) && item.title == "Subscriber Account")
                        localStorage.setItem('account', true);

                        else
                        localStorage.setItem('account', false);

                        this.$router.push({ name: "Home" });
                    }

                    else
                    {
                        this.loading = false;
                        this.toaster = true;
                        this.toastertxt = `${ERR.HANDLE(response.data.code)}`;
                    }
                }

                else{
                    console.log('add profile');
                    if (item.Role === 1 && item.Type === 1){
                        this.ex.modal = true;
                        /*
                        let response = await this.$store.dispatch("linkMobileToEmailCustomer", { profiletroc: item.ProfileTROC})
                        if (response.data.code == 'AP000'){
                            this.$router.push({ name: "Home" });
                        }

                        else
                        {
                            this.loading = false;
                            this.toaster = true;
                            this.toastertxt = `${ERR.HANDLE(response.data.code)}`;
                        }
                        */
                    }

                    if (item.Role === 2 && item.Type === 1){
                        this.innerModal = true;
                        this.ma.customText = "You want to add Corporate Account?"
                        this.ma.modalInfo = {id: 1, name: 2};
                        this.ma.modal_action_type = 'add';
                    }
                    this.loading = false;
                    //this.toaster = true;
                    //this.toastertxt = `To create profile once api ready`;
                }
            }

            catch (error){
                this.loading = false;
                this.dialog = false;
            }
        },

        async linkCorporate(){
            this.loading = true

            try{
                let response = await this.$store.dispatch("linkCorporate", {})
                if (response.data.code === 'AP000')
                {
                    //localStorage.setItem('tempitem', 'registered');
                    this.loading = false;
                    this.toaster = true;
                    this.toasterColor = 'green';
                    this.toastertxt = "Corporate Account Created!";
                    location.reload();
                }

                else if (response.data.code === 'AP002')
                {
                    this.loading = false;
                    this.toaster = true;
                    this.toastertxt = "Invalid TAC";
                }

                else if (response.data.code === 'RD002')
                {
                    this.loading = false;
                    this.toaster = true;
                    this.toastertxt = "This number may already be registered to another account";
                }

                else
                {
                    this.loading = false;
                    this.toaster = true;
                    this.toastertxt = "Something went wrong";
                }
            }

            catch(err){
                this.loading = false;
                this.toaster = true;
                this.toastertxt = "API Error";
            }
        },

        //set the action to be sent to watcher to execute the create/edit function
        async onConfirm(value){
                this.innerModal = false;
                await this.linkCorporate();
        },

        onClosed(value){
            if (value == false){
                this.ex.modal = value;
                this.innerModal = value;
            }
        },

        onResize () {
            this.isMobile = window.innerWidth < 1036
        },

        logout() {
            this.$store.dispatch('userLogout',{
                    router: this.$router
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.slide-enter-active,
.slide-leave-active{
  transition: opacity 0.25s, transform 0.25s;
}

.slide-enter,
.slide-leave-to{
  opacity: 0;
  transform: translateY(10%);
}

.grow2{ cursor: pointer; }
.grow2 { transition: all .2s ease-in-out; }
.grow2:hover { transform: scale(1.05); }

#no-background-color.v-card::before {
  background-color: transparent;
}
</style>